import type { TaskStatusType } from '@frontend/api-types';

export const FILE_INPUT_COUNT_MAX_FILES = 5;

type TaskStatusShortcuts = 'completed' | 'draft' | 'inProgress' | 'waitingOnYou';

export const TASK_STATUSES: { [key in TaskStatusShortcuts]: TaskStatusType[] } = {
  completed: ['archived', 'solved'],
  draft: ['draft'],
  inProgress: ['new', 'open', 'on_hold', 'pending'],
  waitingOnYou: ['pending'],
};
